export default function (state) {
  return {
    ...state,
    open: !state.open,
  }
}
